import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { formatDate } from '@/utils/cal';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
export default {
  name: 'WorkSchedulingModal',
  mixins: [JeecgListMixin],
  data: function data() {
    return {
      title: '操作',
      visible: false,
      pagePath: '/mes/work/record',
      model: {},
      confirmLoading: false,
      manyDate: false,
      health: '',
      tool: '',
      userName: '',
      recordDate: null,
      columns: [],
      isorter: {
        column: 'type',
        order: 'asc'
      } // 表头

      /* columns: [
         {
           title: '序号',
           dataIndex: '',
           key: 'rowIndex',
           width: 60,
           align: "center",
           customRender: function (t, r, index) {
             return parseInt(index) + 1;
           }
         },
         {
           dataIndex: 'recordDate',
           colName: 'record_date',
           title: '排班日期',
           align: "center",
           sorter: true
         },
         {
           dataIndex: 'type_dictText',
           colName: 'type',
           title: '班次类型',
           align: "center",
         },
         {
           dataIndex: 'process',
           colName: 'process',
           title: '本班处理量',
           align: "center",
           sorter: true
         },
         {
           dataIndex: 'power',
           colName: 'power',
           title: '本班耗电量',
           align: "center",
           sorter: true
         },
         {
           dataIndex: 'curStaff_userName',
           colName: 'cur_staff',
           title: '当班人员',
           align: "center",
           sorter: true
         },
         {
           dataIndex: 'successor_userName',
           colName: 'successor',
           title: '接班人',
           align: "center",
           sorter: true
         },
         {
           dataIndex: 'userId_userName',
           colName: 'user_id',
           title: '审核人',
           align: "center",
           sorter: true
         }/!*,
         {
           title: '操作',
           dataIndex: 'action',
           align: "center",
           width: 120,
           scopedSlots: {customRender: 'action'},
         }*!/
       ]*/

    };
  },
  created: function created() {},
  methods: {
    loadData: function loadData(arg) {},
    add: function add() {
      this.loadTreeList();
      this.edit({});
    },
    edit: function edit(siteId, item, value, type) {
      var _this = this;

      this.manyDate = value;
      this.queryParam = {};
      this.queryParam.siteId = siteId;
      this.queryParam.areaType = 1;
      this.visible = true;

      if (value) {
        this.health = '';
        this.tool = '';
        this.userName = '';
        this.queryParam.startTime = item.taskDay;
        this.queryParam.endTime = item.taskDay;
        this.initTableData();
        setTimeout(function () {
          _this.dataSource.forEach(function (v) {
            if (!_this.recordDate) {
              _this.recordDate = v.recordDate ? formatDate(v.recordDate, 'yyyy-MM-dd') : null;
            }

            _this.health = _this.health == '' ? v.health : _this.health + ',' + v.health;
            _this.tool = _this.tool == '' ? v.tool : _this.tool + ',' + v.tool;
            _this.userName = _this.userName == '' ? v.userId_userName : _this.userName + ',' + v.userId_userName;
          });
        }, 500);
        this.$forceUpdate();
      } else {
        this.model = null;

        if (type == 1) {
          // this.queryParam.amClassId = item.amClassId
          var formData = {
            type: type,
            siteId: siteId,
            recordDate: item.taskDay,
            classId: item.amClassId
          };
        } else {
          // this.queryParam.pmClassId = item.pmClassId
          var _formData = {
            type: type,
            siteId: siteId,
            recordDate: item.taskDay,
            classId: item.pmClassId
          };
        }
      }
    },
    onDateRecordDate: function onDateRecordDate(value, dateArray) {
      this.queryParam = {};
      this.queryParam.startTime = dateArray[0];
      this.queryParam.endTime = dateArray[1];
    },
    close: function close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var that = this;
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};